import { LngLatLike } from "mapbox-gl";

import {
  AutomationHandler,
  useRegisterHandlerWithBroker
} from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import { LocationPayload as GoToMapPayload } from "components/automation/types/payloads";
import {
  CommandResult,
  MapCenterAndZoomResult
} from "components/automation/types/results";
import { Topic, Topics } from "components/automation/types/topics";

import { useMapContext } from "./hooks/useMapContext";

export function MapAutomationHandler() {
  const { mapbox } = useMapContext();

  const handler: AutomationHandler = {
    id: "map-automation-handler",
    handles: function (topic: Topic): boolean {
      return topic === Topics.GoTo || topic === Topics.GetMapLocationAndZoom;
    },
    executeCommand: function (command: AutomationCommand): Promise<CommandResult> {
      if (command.topic === Topics.GetMapLocationAndZoom) {
        const center = mapbox.getCenter();
        const zoom = mapbox.getZoom();
        return Promise.resolve({
          status: "ok",
          payload: {
            center: [center.lng, center.lat] as LngLatLike,
            zoom
          } as MapCenterAndZoomResult
        });
      }

      if (command.topic === Topics.GoTo) {
        const payload = command.payload as GoToMapPayload;
        if (payload) {
          mapbox.flyTo({
            center: payload.location,
            zoom: payload.zoom,
            essential: true
          });
        }
      }
      return Promise.resolve({
        status: "ok"
      });
    }
  };
  useRegisterHandlerWithBroker(handler);

  return <></>;
}
